const configs = {
    ethereum: {
        name: 'Ethereum',
        blockchainId: 'ethereum',
        coingeckoAssetId: 'ethereum',
        nativeAssetId: 'eth', // Coin id from the blockchain's coins config
        networkId: 1,
        nativeCurrency: {
            symbol: 'ETH',
            decimals: 18,
        },
        rpcUrl: 'https://mainnet.infura.io/v3/c334bb4b45a444979057f0fb8a0c9d1b',
        rawStatsPath: 'raw-stats',
        logoPath: 'logos/logo_optimized.svg',
        explorerBaseUrl: {
            root: 'https://etherscan.io/',
            address: 'https://etherscan.io/address/',
            tx: 'https://etherscan.io/tx/',
        },
        walletGuideUrl: null,
        display: {
            txCostPrecision: 2,
        },
    },
    fantom: {
        name: 'Fantom',
        blockchainId: 'fantom',
        coingeckoAssetId: 'fantom',
        nativeAssetId: 'ftm', // Coin id from the blockchain's coins config
        networkId: 250,
        nativeCurrency: {
            symbol: 'FTM',
            decimals: 18,
        },
        rpcUrl: 'https://rpc.fantom.network/',
        rawStatsPath: 'raw-stats-ftm',
        logoPath: 'logos/logo_optimized-ftm.svg',
        explorerBaseUrl: {
            root: 'https://ftmscan.com/',
            address: 'https://ftmscan.com/address/',
            tx: 'https://ftmscan.com/tx/',
        },
        walletGuideUrl: 'https://resources.ellipsis.finance/guides/using-curve-on-fantom',
        display: {
            txCostPrecision: 5,
        },
    },
    bsc: {
        name: 'Binance Smart Chain',
        blockchainId: 'bsc',
        coingeckoAssetId: 'binancecoin',
        nativeAssetId: 'bnb', // Coin id from the blockchain's coins config
        networkId: 56,
        nativeCurrency: {
            symbol: 'BNB',
            decimals: 18,
        },
        rpcUrl: 'https://bsc-dataseed2.defibit.io/',
        rawStatsPath: 'raw-stats-bsc',
        logoPath: 'logos/ellipsis.png',
        explorerBaseUrl: {
            root: 'https://bscscan.com/',
            address: 'https://bscscan.com/address/',
            tx: 'https://bscscan.com/tx/',
        },
        walletGuideUrl: 'https://academy.binance.com/en/articles/connecting-metamask-to-binance-smart-chain',
        display: {
            txCostPrecision: 5,
        },
    },
}

const getConfig = () => {
    const id = process.env.VUE_APP_BLOCKCHAIN_ID;
    const supportedIds = Array.from(Object.keys(configs));

    if (!supportedIds.includes(id)) {
        throw new Error(`Invalid env variable VUE_APP_BLOCKCHAIN_ID: "${id}"`);
    }

    return configs[id];
};

module.exports = getConfig();
